import { Controller } from '@hotwired/stimulus'

const FLIP_STEP = 35
const FLIP_MAX_DELAY = 525
const FLIP_DURATION = 600

export default class extends Controller {
  static targets = ['select', 'tab', 'member', 'photoStyleToggle']
  static values = {
    personalPhotosVisible: Boolean,
    currentTeam: String
  }

  disconnect() {
    clearTimeout(this.flipTimer)
  }

  togglePhotoStyle(_event) {
    this.#staggerFlip()
    this.personalPhotosVisibleValue = this.photoStyleToggleTarget.checked
  }

  toggleTeam(event) {
    const tab = event.target.closest('[data-team-target="tab"]')
    const team = tab ? tab.dataset.team : this.selectTarget.value

    this.memberTargets.forEach((member) => {
      const memberTeams = member.getAttribute('data-team')
      member.hidden = !(team === 'all' || memberTeams?.includes(team))
    })

    this.tabTargets.forEach((t) => t.removeAttribute('data-active'))
    if (tab) tab.setAttribute('data-active', '')

    this.selectTarget.value = team
    this.currentTeamValue = team
  }

  // Delays each visible member's flip by its position so the toggle
  // ripples through the grid, then clears the delays so hover flips
  // stay instant.
  #staggerFlip() {
    clearTimeout(this.flipTimer)

    const visible = this.memberTargets.filter((m) => m.offsetParent !== null)

    visible.forEach((member, i) => {
      const delay = Math.min(i * FLIP_STEP, FLIP_MAX_DELAY)
      member.style.setProperty('--flip-delay', `${delay}ms`)
    })

    this.flipTimer = setTimeout(() => {
      visible.forEach((m) => m.style.removeProperty('--flip-delay'))
    }, FLIP_MAX_DELAY + FLIP_DURATION)
  }
}
